
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/thanks",
      function () {
        return require("private-next-pages/contact/thanks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact/thanks"])
      });
    }
  